module.exports = __webpack_public_path__ + "static/media/nexaslim-3.069598de.png";